import script from "./ExtractionOneUploadModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ExtractionOneUploadModal.vue?vue&type=script&setup=true&lang=js"

import "./ExtractionOneUploadModal.vue?vue&type=style&index=0&id=25f60f7e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25f60f7e"]])

export default __exports__